export const DECIMAL_MAGNITUDE_STEP = 3;
export const DECIMAL_APPROXIMATION_STEP = 10;

export function approxFormatNumber(number: number): string {
  if (number >= DECIMAL_APPROXIMATION_STEP * Math.pow(10, 2 * DECIMAL_MAGNITUDE_STEP)) {
    return Math.round(number / Math.pow(10, 2 * DECIMAL_MAGNITUDE_STEP)) + 'M';
  }

  if (number >= Math.pow(10, 2 * DECIMAL_MAGNITUDE_STEP)) {
    return (Math.round(number / Math.pow(10, 2 * DECIMAL_MAGNITUDE_STEP) * DECIMAL_APPROXIMATION_STEP) / DECIMAL_APPROXIMATION_STEP) + 'M';
  }

  if (number >= DECIMAL_APPROXIMATION_STEP * Math.pow(10, DECIMAL_MAGNITUDE_STEP)) {
    return Math.round(number / Math.pow(10, DECIMAL_MAGNITUDE_STEP)) + 'k';
  }

  if (number >= Math.pow(10, DECIMAL_MAGNITUDE_STEP)) {
    return (Math.round(number / Math.pow(10, DECIMAL_MAGNITUDE_STEP) * DECIMAL_APPROXIMATION_STEP) / DECIMAL_APPROXIMATION_STEP) + 'k';
  }

  return String(Math.round(number));
}

export const BINARY_MAGNITUDE_STEP = 10;

export function approxFormatBinaryNumber(number: number): string {
  if (number >= DECIMAL_APPROXIMATION_STEP * (1 << (2 * BINARY_MAGNITUDE_STEP))) {
    return Math.round(number / (1 << (2 * BINARY_MAGNITUDE_STEP))) + '\xa0MiB';
  }

  if (number >= 1 << (2 * BINARY_MAGNITUDE_STEP)) {
    return (Math.round(number / (1 << (2 * BINARY_MAGNITUDE_STEP)) * DECIMAL_APPROXIMATION_STEP) / DECIMAL_APPROXIMATION_STEP) + '\xa0MiB';
  }

  if (number >= DECIMAL_APPROXIMATION_STEP * (1 << BINARY_MAGNITUDE_STEP)) {
    return Math.round(number / (1 << BINARY_MAGNITUDE_STEP)) + '\xa0KiB';
  }

  if (number >= 1 << BINARY_MAGNITUDE_STEP) {
    return (Math.round(number / (1 << BINARY_MAGNITUDE_STEP) * DECIMAL_APPROXIMATION_STEP) / DECIMAL_APPROXIMATION_STEP) + '\xa0KiB';
  }

  return Math.round(number) + '\xa0B';
}

export function getUtmMarks(search: string): string {
  return (search.split('?').filter(item => item)[0] || '').split('&').filter(item => item.indexOf('utm_') === 0).join('&');
}

export function stringOrNumber<T>(value: T): string | number {
  return typeof value === 'number' ? value : String(value)
}

export function compareStringsEmptyLast(s1: string, s2: string): number {
  if (s1 === s2) {
    return 0
  }

  if (s1 === '') {
    return 1
  }

  if (s2 === '') {
    return -1
  }

  if (s1 < s2) {
    return -1
  }

  return 1
}
